/******/
(() => { // webpackBootstrap
    var __webpack_exports__ = {};
    Shopify.theme.jsCollectionList = {
        init: function ($section) {

            // Add settings from schema to current object
            Shopify.theme.jsCollectionList = $.extend(this, Shopify.theme.getSectionData($section));

            let $sliderEl = $section.find('[data-slider]');


            if (this.collection_style == 'slider') {
                this.createSlider($sliderEl);
            }
        },
        createSlider: function ($sliderEl) {

            const slideData = {
                products_per_slide: this.products_per,
                products_available: this.products_available,
                products_limit: this.products_limit,
                show_slider_arrow: this.show_slider_arrow,
                show_slider_dots: this.show_slider_dots
            }

            const slider = $sliderEl.flickity({
                lazyLoad: 2,
                freeScroll: true,
                imagesLoaded: true,
                draggable: true,
                cellAlign: 'left',
                wrapAround: false,
                pageDots: slideData.show_slider_dots,
                contain: true,
                prevNextButtons: slideData.show_slider_arrow,
                initialIndex: 0,
                arrowShape: arrowShape
            });
            slider.flickity('select', 0, false, true);
            slider.on('settle.flickity', function () {
                slider.flickity('resize');
            });

        },
        unload: function ($section) {
            let $slider = $section.find('.flickity-enabled');
            $slider.flickity('destroy');
        }
    }

    /******/
})();